import React from "react";
import { FormRecoveryAccessComponent, FormRecoveryCodeValidateComponent, FormRecoveryPasswordComponent } from "../../../site/impl/components";
import { LoginContainerFactory } from "../screens";

export class RecoveryContainerFactoryImpl implements LoginContainerFactory {
    constructor(
        private currentStep: number,
        private setStep: React.Dispatch<React.SetStateAction<number>>,
        private signupFormData: FormData | undefined,
        private setSignupFormData: React.Dispatch<React.SetStateAction<FormData | undefined>>
    ) { }
    create(): React.ReactNode {
        switch (this.currentStep) {
            case 1:
                return <FormRecoveryAccessComponent setStep={this.setStep} setData={this.setSignupFormData} formData={this.signupFormData} />
            case 2:
                return <FormRecoveryCodeValidateComponent setStep={this.setStep} setData={this.setSignupFormData} formData={this.signupFormData} />
            case 3:
                return <FormRecoveryPasswordComponent setStep={this.setStep} setData={this.setSignupFormData} formData={this.signupFormData} />
        }
    }
}